var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhoShouldLearnIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 21.6L6.858 13.554L8.1 43.2H2.7L3.996 12.393L0 10.8L27 0L54 10.8L27 21.6ZM27 8.1C25.515 8.1 24.3 8.694 24.3 9.45C24.3 10.206 25.515 10.8 27 10.8C28.485 10.8 29.7 10.206 29.7 9.45C29.7 8.694 28.485 8.1 27 8.1ZM27 24.3L42.039 18.279C43.956 20.817 45.279 23.868 45.711 27.189C44.901 27.081 44.064 27 43.2 27C36.315 27 30.294 30.699 27 36.207C25.328 33.401 22.956 31.0773 20.1163 29.4634C17.2765 27.8495 14.0663 27.0006 10.8 27C9.936 27 9.099 27.081 8.289 27.189C8.721 23.868 10.044 20.817 11.961 18.279L27 24.3Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoShouldLearnIcon);
export default __webpack_public_path__ + "static/media/WhoShouldLearnIcon.34d2f92ecaaa19561d495d56771531c3.svg";
export { ForwardRef as ReactComponent };